import { ApiResponses } from 'lib/trpcClient';
import React, { useContext } from 'react';
import useSelectedBankAccount from 'hooks/lp/data/bankAccount/useSelectedBankAccount';

type BankAccount = ApiResponses['bankAccount']['listBankAccounts'][number];

type BankReconciliationContextType = {
  selectedBankAccount: BankAccount | undefined;
  setSelectedBankAccountId: (bankAccountId: string) => void;
  bankAccounts: Array<BankAccount>;
};

const BankReconciliationContext =
  React.createContext<BankReconciliationContextType>({
    selectedBankAccount: undefined,
    setSelectedBankAccountId: () => {},
    bankAccounts: [],
  });

const BankReconciliationContextProvider: React.FC<{
  children: React.ReactNode;
  vehicleId: string;
  bankAccounts: Array<BankAccount>;
}> = ({ children, vehicleId, bankAccounts }) => {
  const [selectedBankAccountId, setSelectedBankAccountId] =
    useSelectedBankAccount(vehicleId);

  const selectedBankAccount =
    bankAccounts?.find(
      (bankAccount) => bankAccount.id === selectedBankAccountId,
    ) ?? bankAccounts?.[0];

  const contextValue = {
    bankAccounts,
    selectedBankAccount,
    setSelectedBankAccountId,
  };

  return (
    <BankReconciliationContext.Provider value={contextValue}>
      {children}
    </BankReconciliationContext.Provider>
  );
};

export const useBankReconciliationContext = () =>
  useContext(BankReconciliationContext);

export default BankReconciliationContextProvider;
